import * as P from "fp-ts-routing";

export type Reports2Route = {};

export const reports2PageMatch = P.lit("reports_archive");
